export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/meeting/index/resources/computed.js